import { Box, CheckBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useCallback, useEffect, useState } from 'react'
import { loginStrings } from '../../../data/static/strings'
import { useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { removeDataFromStorage, storeData, testProps, useWindowDimensions } from '../../../util/util'
import { styles } from '../styles'

interface RememberMeProps {
  enteredMobile?: string
  btnLoading: boolean
  onChecked: (isChecked: boolean) => void
  allValues?: any
  isChecked: boolean
}

const RememberMe: FC<RememberMeProps> = ({ btnLoading, allValues, isChecked, onChecked }: RememberMeProps) => {
  const [isRemembered, setRememberMe] = useState(isChecked)
  const { updateMobile } = useStores((root) => ({
    updateMobile: root.settings.metaData.updateMobileNumber,
  }))
  const updateRememberMe = useCallback((value) => onChecked(value), [onChecked])

  const width = useWindowDimensions()

  const themedStyle = styles(width)

  useEffect(() => {
    if (allValues?.mobileNumber?.length > 9) {
      if (isRemembered) {
        storeData(loginStrings.isRemembered, true)
      } else {
        removeDataFromStorage(loginStrings.isRemembered)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRemembered, updateMobile])

  const handleRememberMe = () => {
    setRememberMe(!isRemembered)
    updateRememberMe((prevState: boolean) => !prevState)
  }
  const { navigate } = useNavigation()
  const handleForgotPwdPress = () => {
    if (!btnLoading) {
      // navigate(Routes.FORGOT_PASSWORD)
      navigate(Routes.FORGOT_PASSWORD, { path: Routes.FORGOT_PASSWORD })
    }
  }

  return (
    <Box {...themedStyle.loginExtraItemStyle}>
      <Box flexDirection={'row'} underlayColor={'TRANSPARENT'} alignItems={'center'}>
        <CheckBox
          loading={btnLoading}
          checked={isRemembered}
          {...testProps('remember-checkbox')}
          color={'BLUE'}
          onChange={handleRememberMe}
        />
        <Spacer size={10} direction="horizontal" />
        <Text
          testID={isRemembered ? 'remember-checked' : 'remember-unchecked'}
          fontFamily={'jiotype-medium'}
          color={'PRIMARY_GREY'}
          fontSize={12}
          fontWeight={'500'}>
          {loginStrings.rememberMe}
        </Text>
      </Box>
      <Box onPress={handleForgotPwdPress} {...testProps('forgot-pwd-button')} underlayColor={'TRANSPARENT'}>
        <Text fontFamily={'jiotype-medium'} color={'BLUE'} fontSize={12} fontWeight={'500'}>
          {loginStrings.forgotPwd}
        </Text>
      </Box>
    </Box>
  )
}

export default RememberMe
